export default __webpack_public_path__ + "static/swish-613198c445d012020a5e628edfd84079.svg";